/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 11/13/2015
 * Time: 3:58 PM
 */
(function($) {
    $.widget("ca.caDatePickerProUI", {
        options: {
            width: '',
            startDate: undefined,
            endDate: undefined,
            dateSeparator: '/',
            shortDateFormat: 'mm/dd/yy'
        },

        _create : function() {
            var input = this.element;
            var datePickerButton = input.parents('.input-group').find('.datepicker-btn');
            var _this = this;
            if(input.data('short-date-format')) {
                this.options.shortDateFormat = input.data('short-date-format');
            }

            input.datepicker({
                autoclose: true,
                todayHighlight: true,
                toggleActive: false,
                startDate: this.options.startDate,
                endDate: this.options.endDate
            })
                .on('show', function() {
                    input.data('previousDate', $(this).val());  // this hack is a workaround for bootstrap-datepicker feature "toggleActive" that is not supported in this version
                })
                .on('changeDate', function() { // this hack is a workaround for bootstrap-datepicker feature "toggleActive" that is not supported in this version
                    var currentValue = $(this).val();
                    var previousDate = input.data('previousDate');

                    if (currentValue === '' || currentValue === null) {
                        $(this).val(previousDate).datepicker('update');
                        return false;
                    }
                });

            const inputDatepicker = this.element.closest('.ca-datepicker-proui').find('.btn');

            if (this.options.disabled) {
                this.element.prop('disabled', true);
                this.element.datepicker('remove');
                inputDatepicker.css('cursor', 'not-allowed');
            } else {
                inputDatepicker.css('cursor', 'pointer');
            }
            datePickerButton.on('click', function () {
                input.trigger('focus');
            });
            input.on('focus', function () {
                datePickerButton.find('a').css('border-color', '#1bbae1');
            });
            $('#date').on('blur', function () {
                datePickerButton.find('a').css('border-color', '#dbe1e8');
            });

            // CACP-10405 - issue #1 fix
            input.on('keyup', function () {
                var currentValue = $(this).val();
                if (currentValue.indexOf(_this.options.dateSeparator) === -1 && currentValue.length === 8) {
                    currentValue = currentValue.substr(0,2) +
                        _this.options.dateSeparator + currentValue.substr(2,2) +
                        _this.options.dateSeparator + currentValue.substr(4,4);
                    let newDate = _this.parseShortDate(currentValue);
                    $(this).val(newDate).datepicker('update');
                }
            });

            // CACP-11415 fix and issue #2 fix from CACP-10405
            input.on('change', function () {
                let currentValue = $(this).val().trim();
                let dateSeparator = _this.options.dateSeparator;
                let regexString = '\\d{1,2}\\' + dateSeparator + '\\d{1,2}\\' + dateSeparator + '\\d{1,2}';
                let regex = new RegExp(regexString);
                if (regex.test(currentValue)) {
                    let newDate = _this.parseShortDate(currentValue);
                    $(this).val(newDate).datepicker('update');
                }
            });

            if (this.options.width) {
                input.parents('.ca-datepicker-proui').css('width', this.options.width);
                var inputWidth = this.options.width - 39;
                input.css('width', inputWidth);
            }
        },

        update: function(date) {
            this.element.val(date);
            this.element.datepicker('update');
        },

        setStartDate: function(date) {
            this.element.datepicker('setStartDate', date);
        },

        parseShortDate: function(input) {
            let date =  $.datepicker.parseDate(this.options.shortDateFormat, input);
            date = new Date(date);
            let parsedDate = input.split(this.options.dateSeparator);
            parsedDate[2] = date.getFullYear();
            return parsedDate.join(this.options.dateSeparator);
        },
    });
})(jQuery);
